import React, { Component } from 'react';
import { postReq } from '../api/restHelper';
import { Formik } from 'formik';

class Registerform extends Component {

    render() {
        return (
            <div className="login-page-forms">
                <h5>به سامانه هنگام خوش آمدید.</h5>
                <h5>برای ورود اول لازم است نام خود را ثبت نمایید</h5>
                <Formik
                    initialValues={{
                        name: ''
                    }}
                    validate={ values => {
                        let errors = {};
                        if (!values.name) {
                            errors.name = 'وارد کردن نام الزامی است';
                        }
                        return errors;
                    }}
                    onSubmit = {( values, actions) => {
                        postReq({
                            name: values.name,
                            phone_number: this.props.phone
                        },'user/register', (res)=>{
                            this.props.changeStatus(2);
                        }, (err) =>{
                            actions.setSubmitting(false);
                        });
                    }}
                    render = { ({values, errors, touched, handleChange, handleSubmit, isSubmitting}) => (
                        <form name="registerForm" onSubmit={handleSubmit}>
                            <div className="content">
                                <div className="form-group">
                                    <input type="text" title="نام و نام خانوادگی" placeholder="نام و نام خانوادگی" name="name" value={values.name} onChange={handleChange} className="text-center" dir="rtl" />
                                    <div className="form-error"> {(touched.name && errors.name) ? (errors.name):(null)} </div>
                                </div>
                            </div>
                            <div className="footer text-center">
                                <button type="submit" disabled={isSubmitting}>ثبت نام</button>
                            </div>
                        </form>
                    )}/>
            </div>
        );
    }
}

export default Registerform;